module.exports = __webpack_public_path__ + "img/task-image-test.7343aee3.png";